import { toBlob } from 'html-to-image';
import { saveAs } from 'file-saver';
import { exportCsv, arrayToCsvRow } from '@/libs/csv';

export async function exportRankingImage(element, fileName) {
  const blob = await toBlob(element, {
    cacheBust: false,
    skipFonts: true,
    backgroundColor: '#ffffff',
  });
  if (!blob) {
    throw new Error('Failed to generate image blob');
  }
  saveAs(blob, fileName);
}

export function generateRankingCsvString(metaRows, headers, dataRows) {
  const lines = [];
  metaRows.forEach(row => lines.push(arrayToCsvRow(row)));
  lines.push('');
  lines.push(arrayToCsvRow(headers));
  dataRows.forEach(row => lines.push(arrayToCsvRow(row)));
  return `${lines.join('\n')}\n`;
}

export function exportRankingCsv(csvString, fileName) {
  exportCsv(csvString, fileName);
}

export const INVALID_FILENAME_CHARS = /[/\\?%*:|"<>\s]/g;

export function sanitizeFileNamePart(str) {
  return str.replace(INVALID_FILENAME_CHARS, '_');
}

export function buildRankingFileName(placeName, floorPlanName, month, rankingType, extension) {
  const parts = [
    sanitizeFileNamePart(placeName),
    sanitizeFileNamePart(floorPlanName),
    month,
    sanitizeFileNamePart(rankingType),
  ];
  return `${parts.join('_')}.${extension}`;
}
